import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const EventCampaignRoutes = ({ DetailReport }: { DetailReport: React.ComponentType }) => (
  <Routes>
    <Route path={ROUTES.EVENT_CAMPAIGN.REPORT_DETAIL.BASE} element={<DetailReport />} />
  </Routes>
);
